const Mutations = Object.freeze({
	SET_SELECTED_GRIDVIEW:
		'projectSettings/connectors/connectorsList/SET_SELECTED_GRIDVIEW',
	SET_CONNECTORS: 'projectSettings/connectors/connectorsList/SET_CONNECTORS',
});

export const Actions = Object.freeze({
	CLEAR: 'projectSettings/connectors/connectorsList/CLEAR',
	ADD_CONNECTOR: 'projectSettings/connectors/connectorsList/ADD_CONNECTOR',
	UPDATE_CONNECTOR:
		'projectSettings/connectors/connectorsList/UPDATE_CONNECTOR',
	DELETE_CONNECTOR:
		'projectSettings/connectors/connectorsList/DELETE_CONNECTOR',

	LOAD_SELECTED_GRID_VIEW:
		'projectSettings/connectors/connectorsList/LOAD_SELECTED_GRID_VIEW',
	LOAD_CONNECTORS:
		'projectSettings/connectors/connectorsList/LOAD_CONNECTORS_BY_GRID_VIEW_ID',
});

export const Getters = Object.freeze({
	SELECTED_GRID_VIEW:
		'projectSettings/connectors/connectorsList/SELECTED_GRID_VIEW',
	GRID_VIEW_FIELDS:
		'projectSettings/connectors/connectorsList/GRID_VIEW_FIELDS',
	CONNECTORS: 'projectSettings/connectors/connectorsList/CONNECTORS',
});

import { GeneralActions } from '../../../../../actions';
import dataService from '../../../../../../services/data/projectSettingsService';

import connectorFilters from './connectorFilters';
import connectorHeaders from './connectorHeaders';

export default {
	state: {
		selectedGridView: null,
		connectors: [],
	},
	modules: { connectorFilters, connectorHeaders },
	mutations: {
		[Mutations.SET_SELECTED_GRIDVIEW](state, item) {
			state.selectedGridView = item;
		},
		[Mutations.SET_CONNECTORS](state, items) {
			state.connectors = items;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_CONNECTORS, []);
				commit(Mutations.SET_SELECTED_GRIDVIEW, null);
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},
		[Actions.ADD_CONNECTOR]({ dispatch, commit, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.addGridViewConnectors(item)
					.then((resp) => {
						let connectors = state.connectors;
						connectors.push(resp.data);
						commit(Mutations.SET_CONNECTORS, connectors);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.UPDATE_CONNECTOR]({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateGridViewConnectors(item)
					.then(() => {
						let connectors = state.connectors;
						let index = connectors.findIndex(
							(x) => x.Id == item.Id
						);
						if (index >= 0) {
							connectors.splice(index, 1, item);
							commit(Mutations.SET_CONNECTORS, connectors);
						}
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.DELETE_CONNECTOR]({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteGridViewConnectors(item.Id)
					.then(() => {
						let connectors = state.connectors;
						let index = connectors.findIndex(
							(x) => x.Id == item.Id
						);
						if (index >= 0) {
							connectors.splice(index, 1);
							commit(Mutations.SET_CONNECTORS, connectors);
						}
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.LOAD_SELECTED_GRID_VIEW]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_SELECTED_GRIDVIEW, item);
				dispatch(GeneralActions.LOADING, false);
				resolve(true);
			});
		},

		[Actions.LOAD_CONNECTORS]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getGridViewConnectorByGridViewId(id)
					.then((resp) => {
						commit(Mutations.SET_CONNECTORS, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
	},
	getters: {
		[Getters.CONNECTORS]: (state) => {
			if (state.connectors && state.connectors.length > 0) {
				return JSON.parse(JSON.stringify(state.connectors));
			}
			return [];
		},
		[Getters.SELECTED_GRID_VIEW]: (state) => {
			if (!state.selectedGridView) return null;
			return JSON.parse(JSON.stringify(state.selectedGridView));
		},
		[Getters.GRID_VIEW_FIELDS]: (state) => {
			if (!state.selectedGridView) return [];
			if (
				state.selectedGridView.Columns &&
				state.selectedGridView.Columns.length > 0
			) {
				return JSON.parse(
					JSON.stringify(state.selectedGridView.Columns)
				);
			}
			return [];
		},
	},
};
